import React from 'react';
import PropTypes from 'prop-types';
import {Icon, Popup} from 'semantic-ui-react';
import {isEmpty as _isEmpty} from 'lodash';

import {COMPETITOR_NOT_DEFINED, COMPETITOR_NOT_DEFINED_BOTH} from '@constants/variables';
import Chip from '@ui/Chip';
import {getCompetitorsObjectFromEvent} from '@utils/competitorObject';
import {addHasMatchIdToStructure} from '@utils/eventObject';
import {showCopyableIdTooltip} from '@utils/eventDetailsHelper';

import {
    getCompetitorCountryFlagsFromEvent,
} from '../../../../../utils/EventsTabsLayout/Details/EventDetails/fields/column3/competitors';

const PopupCompetitor = <Popup
    trigger={<Icon color='red' name='warning sign'/>}
    content='This competitor is excluded.'
    hoverable
/>;

const getCompetitorIdColumnName = (event) => (
    !_isEmpty(event.sr_event) ? 'Competitor' : 'AV competitor'
);

const CompetitorsName = ({competitors, idColumnName}) => {
    const homeCompetitor = competitors.home.name,
        awayCompetitor = competitors.away.name;

    if (!homeCompetitor && !awayCompetitor) {
        return COMPETITOR_NOT_DEFINED_BOTH;
    }

    return (
        <>
            <Competitor competitor={competitors.home} type='home' idColumnName={idColumnName}/>
            &nbsp;:&nbsp;
            <Competitor competitor={competitors.away} type='away' idColumnName={idColumnName}/>
        </>
    );
};

const Competitor = ({competitor, type, idColumnName}) => {
    const competitorName = competitor.name || COMPETITOR_NOT_DEFINED;
    const competitorLabel = competitor.id
        ? showCopyableIdTooltip(competitorName, competitor.id, idColumnName)
        : competitorName;

    if (competitor.is_excluded && 'home' === type) {
        return (<span className='--warning'>
            {PopupCompetitor}
            {competitorLabel}
        </span>);
    } else if (competitor.is_excluded && 'away' === type) {
        return (<span className='--warning awayCompetitor'>
            {competitorLabel}
            {PopupCompetitor}
        </span>);
    }

    return (<span>{competitorLabel}</span>);
};

export const Competitors = ({event}) => {
    const competitorCountryFlagsFromEvent = getCompetitorCountryFlagsFromEvent(event),
        competitorsObject = getCompetitorsObjectFromEvent(addHasMatchIdToStructure(event)),
        idColumnName = getCompetitorIdColumnName(event);
    const underageCompetitors = event.sr_event?.match?.has_underage_competitors
            && <Chip size='small' color='error' label='Underage competitors' className='--marginLeft-0-5-em' />;

    if (competitorCountryFlagsFromEvent.home || competitorCountryFlagsFromEvent.away) {
        return (
            <span key={'competitorsName'}>
                {competitorCountryFlagsFromEvent.home}
                <CompetitorsName competitors={competitorsObject} idColumnName={idColumnName}/>
                {competitorCountryFlagsFromEvent.away}
                {underageCompetitors}
            </span>
        );
    }

    return (
        <>
            <CompetitorsName competitors={competitorsObject} idColumnName={idColumnName}/>
            {underageCompetitors}
        </>
    );
};

Competitor.propTypes = {
    competitor: PropTypes.object.isRequired,
    idColumnName: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
};

CompetitorsName.propTypes = {
    competitors: PropTypes.object.isRequired,
    idColumnName: PropTypes.string.isRequired,
};

Competitors.propTypes = {
    event: PropTypes.object.isRequired,
};
